import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=0ace457c&"
import script from "./PaymentButton.vue?vue&type=script&lang=ts&"
export * from "./PaymentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports